import { Injectable } from '@angular/core';
// import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  constructor() { }


  /**
   * Encrypt data securely using AES-256-GCM
   * @param secret Secret key shared with backend
   * @param data   Object to encrypt
   * @returns {Promise<{iv: string, ciphertext: string}>}
   */

  arrayBufferToBase64(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  async encryptData(data: any, secret: string) {
    try {
      // 1) Derive key the same way backend does: SHA-256(secret)
      const secretBytes = new TextEncoder().encode(secret);
      const digest = await crypto.subtle.digest('SHA-256', secretBytes);
      const keyBytes = new Uint8Array(digest); // 32 bytes

      // 2) Import key for AES-CBC
      const cryptoKey = await crypto.subtle.importKey(
        'raw',
        keyBytes,
        'AES-CBC',
        false,
        ['encrypt']
      );

      // 3) IV and encryption
      const iv = crypto.getRandomValues(new Uint8Array(16));
      const jsonString = JSON.stringify(data);
      const dataBytes = new TextEncoder().encode(jsonString);

      const encryptedBuffer = await crypto.subtle.encrypt(
        { name: 'AES-CBC', iv },
        cryptoKey,
        dataBytes
      );

      // 4) Prefix IV and base64 encode
      const combined = new Uint8Array(iv.length + encryptedBuffer.byteLength);
      combined.set(iv);
      combined.set(new Uint8Array(encryptedBuffer), iv.length);

      return this.arrayBufferToBase64(combined.buffer);
    } catch (error) {
      console.error('Encryption failed:', error);
      throw error;
    }
  }
}
